// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled from 'styled-components';
import { generateId, mobileView } from '../api/utility';
import { useGlobalState } from '../globalState/GlobalStateProvider';

const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
`;
const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0.25em 0.5em;
`;
const RadioCSS = styled.label`
	cursor: ${({ disabled }) => disabled ? 'default' : 'pointer'};
	width: 1em;
	height: 1em;
	background: ${({ theme }) => theme.tertiary};
    display: flex;
    align-items: center;
    justify-content: center;
	border-radius: 50%;
	position: relative;
    &:after {
        content: '';
        position: absolute;
        width: 0.1em;
        height: 0.1em;
        background: #fff;
	    border-radius: 50%;
        transition: 0.3s;
    }
    &:hover:after {
        width: 0.3em;
        height: 0.3em;
    }
`;
const InputCSS = styled.input`
    display: none;
    cursor: inherit;
    
    &:checked + label {
        transition: background 0.3s;
        background:  ${({ theme, mobile }) => mobile ? theme.mobile.active : theme.active};
    }
    &:checked + label:after {
        width: 0.7em;
        height: 0.7em;
    }
    &:disabled + label:after {
        background: ${({ theme }) => theme.disabled};
    }
`;
const MinContent = styled.div`
    margin: 0 0.5em;
`;

const Radio = ({ ...props }) => {
    const { state: {
        // mobileView,
    } } = useGlobalState();

    const id = generateId();
    return (
        <Row>
            <MinContent>
                {props.label}
            </MinContent>
            <Wrapper>
                <InputCSS type="radio" id={id} mobile={mobileView} {...props} />
                <RadioCSS htmlFor={id}  {...props} />
            </Wrapper>
        </Row>
    );
}

export default Radio;